import React from "react";
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import 'dayjs/locale/pt-br';

import { formatarCPF, formatarTelefone, criarHashKey } from '../../utils/Formatters';
import OpenDatePicker from '../../utils/OpenDatePicker';

export default function Campo(props) {

  const valorOpcaoUUID = props.campo.valor.valor_opcao_uuid ? props.campo.valor.valor_opcao_uuid : '';
  const opcao = props.campo.opcoes.find(opcao=>opcao.opcao_uuid === valorOpcaoUUID);
  let opcaoSimNao = false;
  if ((opcao !== null) && (opcao !== undefined) && ((opcao.opcao_nome === 'Sim') || (opcao.opcao_nome === 'Não'))) {
    opcaoSimNao = true;
  }

  const textField = (props) => {
    return (
      <TextField
        fullWidth
        slotProps={{ inputLabel: { shrink: true } }}
        id={props.campo.campo_variavel}
        name={props.campo.campo_variavel}
        label={props.campo.campo_nome}
        defaultValue={props.campo.valor.valor_definido}
        multiline={props.campo.campo_numero_linhas > 1}
        rows={props.campo.campo_numero_linhas}
      />
    );
  };

  const cpf = (props) => {
    return (
      <TextField
        fullWidth
        slotProps={{ inputLabel: { shrink: true } }}
        id={props.campo.campo_variavel}
        name={props.campo.campo_variavel}
        label={props.campo.campo_nome}
        defaultValue={props.campo.valor.valor_definido}
        onChange={(event)=>{
          event.target.value = formatarCPF(event.target.value);
        }}
        placeholder="000.000.000-00"
      />
    );
  };

  const telefone = (props) => {
    return (
      <TextField
        fullWidth
        slotProps={{
          inputLabel: { shrink: true },
        }}
        id={props.campo.campo_variavel}
        name={props.campo.campo_variavel}
        label={props.campo.campo_nome}
        defaultValue={props.campo.valor.valor_definido}
        onChange={(event)=>{
          event.target.value = formatarTelefone(event.target.value);
        }}
        placeholder="(99) 99999-9999"
      />
    );
  };

  const select = (props) => {

    const campo = { ...props.campo };
    if ( (campo.valor.valor_opcao_uuid === undefined) || (campo.valor.valor_opcao_uuid === null) ) {
      campo.valor.valor_opcao_uuid = '';
    }

    return (
      <>
        <TextField
          fullWidth
          slotProps={{ inputLabel: { shrink: true } }}
          id={props.campo.campo_variavel}
          name={props.campo.campo_variavel}
          label={props.campo.campo_nome}
          value={props.campo.valor.valor_opcao_uuid}
          select
          onChange={(event)=>{
            props.handleChange(
              props.campo.valor.valor_uuid,
              event.target.value,
              event,
            )
          }}
        >
          {props.campo.opcoes.map((option) => (
            <MenuItem key={option.opcao_uuid} value={option.opcao_uuid}>
              {option.opcao_nome}
            </MenuItem>
          ))}
        </TextField>
        {
          opcaoSimNao ? (
            <TextField
              sx={{ marginTop: '10px' }}
              fullWidth
              slotProps={{ inputLabel: { shrink: true } }}
              key={criarHashKey(props.campo.valor.valor_definido)}
              id={`${props.campo.campo_variavel}#valor`}
              name={`${props.campo.campo_variavel}#valor`}
              label={`${props.campo.campo_nome} (Observações)`}
              defaultValue={props.campo.valor.valor_definido}
              multiline
              rows={4}
            />
          ) : (<></>)
        }
      </>
    );
  };

  const datePicker = (props) => {
    return (
      <OpenDatePicker {...props} />
    );
  };

  const campoPorTipo = (props) => {
    switch (props.campo.tipo_campo_nome) {
      case "select":
        return select(props);
      case "cpf":
        return cpf(props);
      case "telefone":
        return telefone(props);
      case "datePicker":
        return datePicker(props);
      default:
        return textField(props);
    }
  };

  return (
    <Grid item="true" size={12} sx={props.cssGrid}>
     {campoPorTipo(props)}
    </Grid>
  );
}
